module.exports = __webpack_public_path__ + "static/media/undraw-doctor-kw-5-l .a51ae240.svg";